import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthErrorPage as FoundationAuthErrorPage } from '@foundation-bb/foundation-auth-ui';

/**
 * Standalone auth error route (`/auth/error?code=<code>`). The backend redirects here for
 * failures that aren't tied to the SSO callback (magic-link rejection, etc.); the code maps
 * to a localized message via Foundation's authErrorMessageKey.
 */
export default function AuthErrorPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const code = params.get('code');

  return (
    <FoundationAuthErrorPage
      code={code}
      t={t}
      labels={{
        title: t('auth.error.title'),
        backToSignIn: t('auth.sso.backToLogin'),
      }}
      renderBackLink={(label) => <Link to="/login">{label}</Link>}
    />
  );
}
